import { all } from "redux-saga/effects";

import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import categorySaga from "./category/saga";
import courseSaga from "./course/saga";
import subCourseSaga from "./subCourse/saga";
import videoSaga from "./video/saga";
import newsSaga from "./news/saga";
import WhoAreWeSaga from "./whoAreWe/saga";
import faqSaga from "./faq/saga";
import testimonialsSaga from "./testimonials/saga";
import bannerSaga from "./banner/saga";
import UsersSaga from "./users/saga";
import OrderSaga from "./orders/saga";
import MainBannerSaga from "./Main_banner/saga";
import enqSaga from "./Enquiries/saga";
import subSaga from "./Subscriptions/saga";
import NewsBannerSaga from "./news_banner/saga";
import currencySaga from "./currency/saga";
import revenueSaga from "./revenue/saga";
import footerSaga from "./footer/saga";
import InfluencerSaga from "./Influencer/saga";
import CongratsBoxSaga from "./congratsBox/saga";
import CouponsSaga from "./Coupons/saga";
import payoutSaga from "./payout/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    layoutSaga(),
    categorySaga(),
    courseSaga(),
    subCourseSaga(),
    videoSaga(),
    newsSaga(),
    NewsBannerSaga(),
    WhoAreWeSaga(),
    subSaga(),
    enqSaga(),
    faqSaga(),
    testimonialsSaga(),
    MainBannerSaga(),
    OrderSaga(),
    UsersSaga(),
    bannerSaga(),
    currencySaga(),
    revenueSaga(),
    footerSaga(),
    InfluencerSaga(),
    CouponsSaga(),
    CongratsBoxSaga(),
    payoutSaga(),
  ]);
}
